type ConsoleMethods = Pick<
  Console,
  'info' | 'warn' | 'error' | 'debug' | 'trace'
>;
type LogLevel = keyof ConsoleMethods;

const noop: (...args: unknown[]) => void = () => {};
const isDev = import.meta.env.MODE === 'development';

const levels: LogLevel[] = ['info', 'warn', 'error', 'debug', 'trace'];

export const devLogger: ConsoleMethods = Object.fromEntries(
  levels.map((level) => [
    level,
    // eslint-disable-next-line no-console
    isDev ? console[level].bind(console) : noop,
  ]),
) as ConsoleMethods;
